<div class="modal-header">
    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="close()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">{{title}}</h4>
</div>
<form [formGroup]="form">
    <div class="modal-body">
        <validation-results [validationResults]="validationResults" *ngIf="validationResults?.validationResults?.length"></validation-results>
        <div class="row">
            <div class="col-sm-12 mvd_form-group">
                {{data.message}}
            </div>
        </div>
        <div class="row" *ngIf="isPOSAvailable">
            <div class="col-sm-12 mvd_form-group">
                <label class="required" title="">Point Of Sale Device</label>
                <p-dropdown [options]="posDeviceDropdown" filter="filter" formControlName="pointOfSaleDeviceId"></p-dropdown>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="btn--group">
            <button class="btn--default" type="button" aria-label="Close" (click)="close()">Cancel</button>
            <button class="btn--primary" type="button" (click)="confirm()" [disabled]="form.invalid || isSubmitted" >Confirm</button>
        </div>
    </div>
</form>